import { Suspense } from 'react';
import Header from '../feature/Header';
import Footer from '../feature/Footer';
import BackToTop from '../feature/BackToTop';

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-white text-xl">Loading...</div>
          </div>
        }>
          {children}
        </Suspense>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}